export default {
  message: {
    "error": "عذرًا! حدث خطأ ما.",
    "Sorrysomeerrorsoccurred": "حدث خطأ غير متوقع. يمكنك محاولة تغيير اللغة أو الخروج وإعادة تشغيل التطبيق.",
    "quit": "خروج",
    "language": "اللغة",
    "Youcanchangethelanguagehere": "يمكنك تغيير اللغة هنا!",
    "current": "الحالي",
    "home": "الرئيسية",
    "friends": "الأصدقاء",
    "wallet": "المحفظة",
    "aboutus": "معلومات عنا",
    "Sharewithfriends": "شارك مع الأصدقاء",
    "copyFailure": "فشل النسخ",
    "copySuccess": "نجاح النسخ",
    "Claimreward": "استلام المكافأة",
    "DailyLogin": "تسجيل الدخول اليومي",
    "noInvitationsYet": "لا توجد دعوات بعد",
    "LoadMore": "تحميل المزيد",
    "WatchAD": "شاهد الإعلان",
    "continue": "استمر",
    "Congratulations": "مبروك",
    "MyFriends": "أصدقائي",
    "Invitefriends": "دعوة الأصدقاء",
    "Invitepremiumfriends": "دعوة الأصدقاء المميزين",
    "DailyTasks": "المهام اليومية",
    "inviteDesc": "+{num} ${name} مقابل كل صديق تدعوه",
    "DailyTasksDesc": "أكمل المهام للحصول على المزيد من الهدايا المجانية",
    "SponsorsandPartners": "الرعاة والشركاء",
    "Receivingwallet": "محفظة الاستلام",
    "Enterwalletaddress": "أدخل عنوان محفظة {name}",
    "Claim": "استلام",
    "Booster": "معزز",
    "RentPeriod": "مدة الإيجار",
    "days30": "30 يوماً",
    "Dailyprofit": "الربح اليومي",
    "Totalprofit": "إجمالي الربح",
    "Quantity": "الكمية",
    "RentPrice": "سعر الإيجار",
    "RentMiner": "استئجار عامل التعدين",
    "Insufficient": "لا توجد دعوات كافية",
    "InsufficientMsg": "تحتاج إلى دعوة {num} أصدقاء لكسب المزيد من الملحقات.",
    "Settings": "الإعدادات",
    "copyid": "نسخ المعرف",
    "UpgradeSuccessfully": "ترقية ناجحة",
    "Name": "الاسم",
    "userinfo": "معلومات المستخدم",
    "disconnect": "قطع الاتصال",
    "Startmining": "بدء التعدين",
    "Welcome": "مرحباً بك في {name}",
    "Withdrawal": "السحب",
    "Minimumamount": "الحد الأدنى من المبلغ",
    "Networkfee": "رسوم الشبكة",
    "Enteramount": "أدخل المبلغ",
    "Submit": "إرسال",
    "MinimumTip": "المبلغ للسحب صغير جداً. الحد الأدنى للمبلغ للسحب: {num}",
    "MaximumTip": "المبلغ غير كافٍ، الحد الأقصى الذي يمكنك سحبه هو: {num}",
    "SubmittedTip": "تم الإرسال، من المتوقع أن يتم معالجته خلال 30-60 يوم عمل",
    "WithdrawStatus": "الحالة",
    "Submissiontime": "وقت الإرسال",
    "WithdrawAwaitTip": "* من المتوقع أن يستغرق 30-60 يوم عمل. دعوة المزيد من الأصدقاء يمكن أن تسرع من عملية المراجعة.",
    "Processing": "جاري المعالجة",
    "Amount": "المبلغ",
    "Numberoffriends": "عدد الأصدقاء: {now}/{limit}",
    "InviteTip": "لإجراء سحبك الأول، تحتاج إلى دعوة {limit} أصدقاء للانضمام إلى تطبيق التعدين.",
    "openonphone": "افتح هذا الرابط على هاتفك.",
    "claimTip": "المبلغ الذي يمكن استلامه صغير جداً. الحد الأدنى للمبلغ الذي يمكن استلامه هو: {num}",
    "WalletBalance": "رصيد المحفظة",
    "Withdraw": "سحب",
    "SetWalletAddress": "تعيين عنوان المحفظة",
    "WithdrawalRecord": "سجل السحب",
    "Norecords": "لا توجد سجلات",
    "Whatis": "ما هو {name}؟",
    "All": "الكل",
    "save": "حفظ",
    "successWithdrawal": "نجاح المسح {num}",
    "secondsago": "منذ {time} ثانية",
    "Loading": "جارٍ التحميل...",
    "PaymentConfirming": "جارٍ فحص حالة المعاملة...",
    "Check": "تحقق",
    "CheckFail": "لم تكتمل المعاملة. يرجى التحقق مرة أخرى بعد 5 ثوانٍ.",
    "Addname": "أضف '{name}' إلى اسمك",
    "Restattcheck": "أعد تشغيل التطبيق للتحقق",
    "Copyname": "نسخ '{name}'",
    "SubmissionFailed": "فشل الإرسال، يرجى المحاولة لاحقاً",
    "WithdrawalReview": "مراجعة السحب",
    "WebWithdrawAwaitTip": "* من المتوقع أن يستغرق 24-48 ساعة. دعوة المزيد من الأصدقاء يمكن أن تسرع من عملية المراجعة.",
    "Success": "نجاح",
    "Rejection": "رفض",
    "WebSubmittedTip": "تم الإرسال، سنقوم بمعالجته في أقرب وقت ممكن.",
    "select_payment_method": "اختر وسيلة الدفع",
    "total_amount": "إجمالي المبلغ",
    "next_step": "الخطوة التالية",
    "creating_order": "إنشاء الطلب...",
    "order_created": "تم إنشاء الطلب",
    "order_status": "حالة الطلب",
    "order_id": "معرّف الطلب",
    "order_amount": "مبلغ الطلب",
    "order_status_desc": "وصف حالة الطلب",
    "payment_cancelled": "تم إلغاء الدفع",
    "opening_payment": "جارٍ فتح الدفع...",
    "payment_success": "الدفع ناجح",
    "payment_failed": "فشل الدفع",
    "payment_pending": "الدفع معلق",
    "payment_processing": "يتم معالجة الدفع",
    "create_order_failed": "فشل إنشاء الطلب",
    "creating_ton_order": "جاري إنشاء طلب TON...",
    "check_payment_status": "جارٍ التحقق من حالة الدفع...",
    "use_ton_payment": "استخدم دفع TON",
    "connect_wallet": "اتصال المحفظة",
    "start_transaction": "بدء المعاملة",
    "address": "العنوان",
    "amount_ton": "المبلغ TON",
    "copy": "نسخ",
    "comment_memo": "ملاحظة التعليق",
    "comment_memo_desc": "يرجى إدخال ملاحظة التعليق",
    "comment_memo_placeholder": "أدخل ملاحظة التعليق",
    "amount": "المبلغ",
    "wallet_address": "عنوان المحفظة",
    "you_can_choose_to_connect_wallet_to_pay": "يمكنك اختيار ربط المحفظة للدفع",
    "or_manually_transfer_to_the_above_address": "أو نقل يدوي إلى العنوان أعلاه (تأكد من أن المبلغ والملاحظة يجب أن تكون بالضبط هي نفسها)",
    "transaction_success": "نجاح المعاملة",
    "transaction_failed": "فشل المعاملة",
    "transaction_error": "خطأ في المعاملة",
    "transaction_status": "حالة المعاملة",
    "transaction_id": "معرف المعاملة",
    "transaction_amount": "مبلغ المعاملة",
    "transaction_status_desc": "وصف حالة المعاملة",
    "miner_detail": "تفاصيل المعدن",
    "rent_period": "فترة الإيجار",
    "days": "{days} أيام",
    "daily_yield": "العائد اليومي",
    "total_yield": "إجمالي العائد",
    "invite_friends": "دعوة الأصدقاء",
    "price": "السعر",
    "rent": "إيجار",
    "free_claim": "استلام مجاني",
    "redeem": "استرداد",
    "buy": "إيجار",
    "invite_friends_not_enough": "دعوة الأصدقاء ليست كافية",
    "redeem_success": "نجاح الاسترداد",
    "redeem_failed": "فشل الاسترداد",
    "rent_success": "نجاح الإيجار",
    "rent_failed": "فشل الإيجار",
    "TotalPower": "إجمالي الطاقة",
    "MaxQuantity": "تم الوصول إلى القيمة القصوى",
    "Running": "قيد التشغيل",
    "Stop": "إيقاف",
    "Withdrawalunlock": "فتح السحب",
    "Close": "إغلاق",
    "Delivering": "يتم التسليم",
    "Duetothelargenumber": "نظرًا للعدد الكبير من المستلمين، من المتوقع أن يصل توزيع الجوائز في غضون 15-20 يوم عمل",
    "WithdrawalunlockTip": "تحتاج إلى {num} أصدقاء تم دعوتهم لإكمال المهام/ربط المحافظ لفتح السحب",
    "mining_title": "روبوت",
    "Upgrade": "ترقية",
    "partner": "شريك",
    "faq": "الأسئلة الشائعة",
    "task": "مهمة",
    "OpenRobot": "افتح الروبوت",
    "MyRobot": "روبوتي",
    "Level": "المستوى",
    "Commission": "العمولة",
    "DirectFriends": "الأصدقاء المباشرين",
    "Feedback": "ملاحظات",
    "Pleaseenteryouremailaddress": "يرجى إدخال عنوان بريدك الإلكتروني",
    "Inputfeedbackcontent": "أدخل محتوى التعليق",
    "Submitfeedback": "إرسال الملاحظات",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "تم إرسال الملاحظات بنجاح، شكرًا لملاحظاتك القيمة",
    "Feedbacksubmissionfailed,pleaseretriy": "فشل إرسال الملاحظات، يرجى المحاولة مرة أخرى",
    "Addressformaterror": "خطأ في تنسيق العنوان",
    "Readclipboardfailed": "فشل قراءة الحافظة",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "لقد قمت بالتعليق بالفعل اليوم، يرجى العودة غدًا",
    "Record": "سجل",
    "Newuserguidance": "عرض جولة الترحيب",
    "Usetonwallet": "استخدم محفظة TON",
    "Reward": "الجائزة",
    "Connectwallet": "ربط المحفظة",
    "Notconnected": "غير متصل",
    "Disconnect": "فصل",
    "AboutTAI": "تفاصيل الرمز",
    "WithdrawalRecordDesc": "سجل السحب",
    "StartAItrading": "ابدأ التداول باستخدام الذكاء الاصطناعي",
    "Next": "التالي",
    "Start": "بدء",
    "WithdrawalSuccess": "نجاح السحب",
    "WithdrawalFail": "فشل السحب",
    "Max": "الأقصى",
    "WithdrawalRecords": "سجلات السحب",
    "Commissionrules": "قواعد العمولة",
    "Mycommission": "عمولتي",
    "Shop": "التسوق",
    "BuyDifferentAIrobots": "قم بالترقية مع أجهزة الكمبيوتر لعمليات المسح الأسرع!",
    "CurrentRunningAIrobots": "روبوتات الذكاء الاصطناعي الجارية الحالية",
    "DailyProfit": "الربح اليومي",
    "Buy": "شراء",
    "ValidityPeriod": "مدة الصلاحية",
    "Days": "أيام",
    "Price": "السعر",
    "APY": "APY",
    "NoRobot": "لا توجد قوة حسابية",
    "RemainingTime": "الوقت المتبقي",
    "InviteandEarn": "ادعُ واكسب",
    "InvitDec": "ادعُ أصدقاءك للانضمام إلى تداول الذكاء الاصطناعي واكسب عمولات USDT ورموز الهدايا المجانية معًا!",
    "ShareToGroups": "شارك في المجموعات",
    "Select_payment_method": "اختر طريقة الدفع",
    "twa_pay_tip_with_memo": "يرجى التأكد من أن العنوان، المبلغ، والمذكرة متسقة لعملية التحويل.",
    "twa_pay_tip": "يرجى التأكد من أن العنوان والمبلغ صحيحين لعملية التحويل.",
    "twa_pay_tip_placeholder": "أدخل ملاحظة التعليق",
    "twa_pay_tip_placeholder_with_memo": "أدخل ملاحظة التعليق مع ملاحظة",
    "twa_pay_tip_placeholder_without_memo": "أدخل ملاحظة التعليق بدون ملاحظة",
    "twa_pay_tip_placeholder_with_memo_placeholder": "أدخل ملاحظة التعليق مع ملاحظة",
    "twa_pay_tip_placeholder_without_memo_placeholder": "أدخل ملاحظة التعليق بدون ملاحظة",
    "realtime_ai": "تداول الذكاء الاصطناعي في الوقت الحقيقي",
    "check_transaction_status": "تحقق من حالة المعاملة",
    "transaction_wait": "تتم معالجة المعاملة. يمكنك الخروج من التطبيق. ستتلقى رسالة تُعلمك عندما تكتمل.",
    "Pleaseenteravalidemailaddress": "يرجى إدخال عنوان بريد إلكتروني صالح",
    "max_robot_tip": "تم الوصول إلى حد الشراء - جرب خطة أخرى للاستمرار في التداول!",
    "connectFailure": "فشل الاتصال بالمحفظة",
    "connectSuccess": "نجاح الاتصال بالمحفظة",
    "PayNow": "ادفع الآن",
    "min_withdrawal_amount": "أقل مبلغ للسحب هو {num} {coin_name}",
    "max_withdrawal_amount": "أعلى مبلغ للسحب هو {num} {coin_name}",
    "balance_not_enough": "ليس لديك رصيد كافٍ لهذا السحب.",
    "Numberofgroups": "عدد المجموعات: {now}/{limit}",
    "Withdraw_success": "السحب ناجح",
    "allProfit": "إجمالي الربح",
    "AnnualProfit": "الأرباح السنوية",
    "ScanWallet": "مسح المحفظة",
    "wallet_check": "wallet_check",
    "Found": "وجدت",
    "ScanSpeed": "سرعة المسح",
    "MyComputingPower": "حساب",
    "Scanning": "جارٍ المسح!",
    "WithdrawDetail": "تفاصيل السحب",
    "ScanSuccess": "لقد زادت نسبة نجاح فحصك!",
    "TaskDescription": "أكمل المهام لزيادة معدل نجاح المسح الخاص بك!",
    "InitializingMiningSystem": "جاري تهيئة نظام المسح...",
    "NoWithdrawalRecord": "لا يوجد سجل سحب",
    "Invite": "الدعوات المطلوبة",
    "Free": "مجاني",
    "Confirm": "تأكيد",
    "RefreshTasks": "تحديث المهام",
    "NumberofGroups": "عدد المجموعات: {now}/{limit}",
    "SendMessage": "أرسل رسالة",
    "NumberofShares": "عدد الأسهم: {now}/{limit}",
    "NumberofTasks": "عدد المهام: {now}/{limit}",
    "CompleteTask": "إكمال المهمة",
    "Accelerated": "مُعَجَّل",
    "Accelerated_withdrawals_success": "سحب مُعَجَّل بنجاح",
    "GoBuy": "اذهب للشراء",
    "SpeedUpScan": "سرعة أكبر",
    "Earnings": "الأرباح",
    "learnMore": "تعرف على المزيد",
    "claimSuccess": "تم استلام المكافأة بنجاح",
    "claimFailed": "فشل الاستلام، يرجى المحاولة مرة أخرى",
    "noDividends": "لا توجد أرباح لاستلامها",
    "dividendsInfoFallback": "دعوة الأصدقاء لكسب مكافآت الإحالة"
}};